// src/App.jsx - Updated with Billing Dashboard route
import { QueryClientProvider } from '@tanstack/react-query'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import ProtectedRoute, { AdminRoute, OperatorRoute } from './components/auth/ProtectedRoute'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './Layout.jsx'
import { queryClient } from './lib/queryClient'

// Import pages
import ActivityLog from './pages/ActivityLog'
import Auto from './pages/Auto'
import AutoArchivio from './pages/AutoArchivio'
import AutoEditPage from './pages/AutoEditPage'
import AutoNotePage from './pages/AutoNotePage'
import BillingDashboard from './pages/BillingDashboard'; // NEW: Import billing dashboard
import Clienti from './pages/Clienti'
import Dashboard from './pages/Dashboard'
import Posizioni from './pages/Posizioni'
import Stati from './pages/Stati'
import UserManagement from './pages/UserManagement'

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true
          }}
        >
          <ProtectedRoute>
            <Layout>
              <Routes>
                {/* Dashboard - Both Admin and Operator can access */}
                <Route path="/" element={
                  <OperatorRoute>
                    <Dashboard />
                  </OperatorRoute>
                } />
                <Route path="/dashboard" element={
                  <OperatorRoute>
                    <Dashboard />
                  </OperatorRoute>
                } />

                {/* Auto Management - Both Admin and Operator can access */}
                <Route path="/auto" element={
                  <OperatorRoute>
                    <Auto />
                  </OperatorRoute>
                } />
                <Route path="/auto/edit/:id" element={
                  <OperatorRoute>
                    <AutoEditPage />
                  </OperatorRoute>
                } />
                <Route path="/auto/note/:id" element={
                  <OperatorRoute>
                    <AutoNotePage />
                  </OperatorRoute>
                } />

                {/* Archive - Admin only */}
                <Route path="/autoarchivio" element={
                  <AdminRoute>
                    <AutoArchivio />
                  </AdminRoute>
                } />

                {/* NEW: Billing Dashboard - Admin only */}
                <Route path="/billing" element={
                  <AdminRoute>
                    <BillingDashboard />
                  </AdminRoute>
                } />

                {/* Activity Log - Admin only */}
                <Route path="/activitylog" element={
                  <AdminRoute>
                    <ActivityLog />
                  </AdminRoute>
                } />

                {/* Admin-only routes */}
                <Route path="/clienti" element={
                  <AdminRoute>
                    <Clienti />
                  </AdminRoute>
                } />
                <Route path="/posizioni" element={
                  <AdminRoute>
                    <Posizioni />
                  </AdminRoute>
                } />
                <Route path="/stati" element={
                  <AdminRoute>
                    <Stati />
                  </AdminRoute>
                } />

                {/* User Management - Admin only */}
                <Route path="/users" element={
                  <AdminRoute>
                    <UserManagement />
                  </AdminRoute>
                } />
              </Routes>
            </Layout>
          </ProtectedRoute>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App